import api from './api';
import axios from 'axios'; // TODO: rimuovere, usare api
import API_CONFIG from '../config/api';

const templateService = {
  // Crea template con upload PDF
  creaTemplate: async (file, nomeTemplate, tipoTemplate, isPrimario, agenziaId) => {
    const formData = new FormData();
    formData.append('template', file);
    formData.append('nomeTemplate', nomeTemplate);
    formData.append('tipoTemplate', tipoTemplate);
    formData.append('isPrimario', isPrimario);

    const response = await api.post(
      `${API_CONFIG.baseURL}/api/template-preventivi/crea/${agenziaId}`,
      formData,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return response.data;
  },

  // Ottieni tutti i template di un'agenzia
  getTemplateAgenzia: async (agenziaId) => {
    const response = await api.get(
      `${API_CONFIG.baseURL}/api/template-preventivi/agenzia/${agenziaId}`,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );

    return response.data;
  },

  // Ottieni template primario per tipo
  getTemplatePrimario: async (agenziaId, tipoTemplate) => {
    const response = await api.get(
      `${API_CONFIG.baseURL}/api/template-preventivi/primario/${agenziaId}/${tipoTemplate}`,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );

    return response.data;
  },

  // Aggiorna template
  aggiornaTemplate: async (templateId, nomeTemplate, isPrimario) => {
    const response = await api.put(
      `${API_CONFIG.baseURL}/api/template-preventivi/${templateId}`,
      {
        nomeTemplate,
        isPrimario
      },
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  },

  // Elimina template
  eliminaTemplate: async (templateId) => {
    const response = await api.delete(
      `${API_CONFIG.baseURL}/api/template-preventivi/${templateId}`,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );

    return response.data;
  },

  // Imposta template come primario
  impostaPrimario: async (templateId) => {
    const response = await api.put(
      `${API_CONFIG.baseURL}/api/template-preventivi/${templateId}/primario`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );

    return response.data;
  },

  // Download template PDF
  downloadTemplate: async (templateId) => {
    const response = await api.get(
      `${API_CONFIG.baseURL}/api/template-preventivi/download/${templateId}`,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        responseType: 'blob'
      }
    );

    return response;
  },

  // Metodo per analizzare i campi di un PDF
  analizzaCampiPdf: async (file) => {
    try {
      const formData = new FormData();
      formData.append('pdf', file);

      const response = await fetch('/api/template-preventivi/analizza-campi-pdf', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: formData
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Errore nell\'analisi del PDF');
      }

      return data;
    } catch (error) {
      console.error('Errore analisi campi PDF:', error);
      throw error;
    }
  }
};

export default templateService; 